const SAVE_TYPE_COURSE = 1;

export const save = async (courseId: string) => {
	return fetch("/api/saved/course", {
		method: "POST",
		credentials: "include",
		headers: {
			"Content-Type": "application/json",
			"Accept": "application/json"
		},
		body: courseId
	});
};

export const unsave = (courseId: string) => {
	return fetch("/api/saved/course", {
		method: "DELETE",
		credentials: "include",
		headers: {
			"Content-Type": "application/json",
			"Accept": "application/json"
		},
		body: courseId
	});
};
